export default function durationFilter(humanizeDurationService) {
  return function(input, unit) {
    return humanizeDurationService.humanize(moment.duration(input, unit).asMilliseconds());
  };
}



// WEBPACK FOOTER //
// ./src/app/common/duration.filter.js